import { Observable, throwError } from "rxjs";
import { defaultIfEmpty, switchMap } from "rxjs/operators";

export function throwErrorOnEmpty<T>(defaultValue: T, errorMessage: string): ((source: Observable<T>) => Observable<T>) {
  return (source: Observable<T>) => source.pipe(
    defaultIfEmpty(defaultValue),
    switchMap((value) => (value === defaultValue ? throwError(() => new Error(errorMessage)) : [value]))
  );
}
